import DOMPurify from 'isomorphic-dompurify';
import Image from 'next/future/image';

const MeetTeamCard = (props: any) => {
  const data = props?.meetTeamData;
  return (
    <section className="your-community-section sv-meet-the-team">
      <div className="container">
        <h2 className="section-heading">{props?.meetTitle}</h2>
        {data &&
          data?.length &&
          data?.map((item: any) => {
            return (
              <>
                <div
                  key={item?.id}
                  className="row align-items-lg-center align-items-md-start align-items-sm-start g-3"
                >
                  <div className="col-lg-6 col-md-6 col-sm-12">
                    <Image
                      sizes="(max-width: 375px) 295px, (max-width: 576px) 540px, (max-width: 768px) 350px, (max-width: 992px) 470px, (max-width: 1280px) 560px"
                      className="img-fluid card-img"
                      src={
                        item.Thumbnail?.data?.attributes?.url
                          ? item.Thumbnail?.data?.attributes?.url
                          : item?.Thumbnail?.data?.attributes?.alternativeText
                      }
                      width="540"
                      height="304"
                      alt={
                        item?.Thumbnail?.data?.attributes?.alternativeText
                          ? item?.Thumbnail?.data?.attributes?.alternativeText
                          : 'alt'
                      }
                    />
                  </div>

                  <div
                    className="col-lg-6 col-md-6 col-sm-12 mt-3 mt-lg-0 mt-md-0"
                    dangerouslySetInnerHTML={{
                      __html: DOMPurify.sanitize(item?.Description),
                    }}
                  ></div>
                </div>
              </>
            );
          })}
      </div>
    </section>
  );
};
export default MeetTeamCard;
